import { ArrowLeftIcon, EyeIcon, EyeOffIcon } from '@heroicons/react/solid';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

const LoginFormEntries = (props) => {
  const [password, setPassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);

  const handleClickShowPassword = () => setShowPassword((prev) => !prev);
  const handleMouseDownPassword = () => setShowPassword((prev) => !prev);

  const handlePasswordChange = (e) => {
    setPassword(e.target.value);
  };

  const handleLogin = (e) => {
    e.preventDefault();
    props.login(password);
    setPassword('');
  };

  return (
    <form onSubmit={handleLogin} className="relative mb-4">
      <div className="relative mb-4">
        <label htmlFor="password" className="leading-7 text-sm text-gray-600">
          Password
        </label>
        <div className="flex gap-2">
          <input
            disabled={props.isFetchingUser}
            type={showPassword ? 'text' : 'password'}
            id="password"
            name="password"
            value={password}
            onChange={handlePasswordChange}
            className="w-full bg-white rounded border border-gray-300 focus:border-accent-500 focus:ring-2 focus:ring-accent-200 disabled:bg-gray-200 text-base outline-none text-gray-700 py-1 px-3 leading-8 transition-colors duration-200 ease-in-out"
          />
          <button
            type="button"
            aria-label="toggle password visibility"
            onClick={handleClickShowPassword}
            onMouseDown={handleMouseDownPassword}
          >
            {showPassword ? (
              <EyeIcon className="h-5 w-5" />
            ) : (
              <EyeOffIcon className="h-5 w-5" />
            )}
          </button>
        </div>
      </div>
      <div className="flex gap-10">
        <button
          type="button"
          className="flex items-center text-gray-500 gap-2 hover:text-gray-800"
        >
          <ArrowLeftIcon className="h-5 w-5" />
          <Link to="/">Back</Link>
        </button>
        <button
          disabled={!password || props.isFetchingUser}
          type="submit"
          className="text-white bg-accent-500 w-full border-0 py-2 px-8 focus:outline-none disabled:bg-gray-500 disabled:text-gray-800 hover:bg-accent-600 rounded text-lg"
        >
          Login
        </button>
      </div>
    </form>
  );
};

export default LoginFormEntries;
